import React, { useEffect, useMemo } from 'react';
import _get from 'lodash/get';
import { useDispatch } from 'react-redux';
import { useData, useStatus } from 'resift';
import queryString from 'query-string';
import { useLocation } from 'react-router';
import makeDeleteEntity from 'fetches/makeDeleteEntity';
import makeGetEntitiesListFetch, { EntitiesRequestQuery } from 'fetches/makeGetEntitiesListFetch';
import makeGetEntityTypeStatus from 'fetches/makeGetEntityTypeStatus';
import * as Types from 'pages/Pages/typings';
import Loader from 'components/Loader';
import PagesTab from './PagesTab';

interface Props {
  entityType: Types.EntityType;
  migrationInProgress: boolean;
  onReload: () => void;
}

function Container({ entityType, migrationInProgress, onReload }: Props) {
  const dispatch = useDispatch();
  const location = useLocation();
  const search = location.search;
  const getLastSyncStatus = makeGetEntityTypeStatus(entityType.id);
  const lastSyncStatusInfo = useData(getLastSyncStatus);

  // entities list
  const getEntitiesList = useMemo(() => makeGetEntitiesListFetch(entityType.id), [entityType.id]);
  const pagesData = useData(getEntitiesList);
  const fetchPagesStatus = useStatus(getEntitiesList);

  // delete:
  const deleteEntity = makeDeleteEntity();

  const handleDeleteEntity = async (entityId: string) => {
    await dispatch(deleteEntity(entityId));
    dispatch(getEntitiesList({ query: { entityTypeId: entityType.id } }));
  };

  useEffect(() => {
    const query = queryString.parse(search) as Partial<EntitiesRequestQuery>;
    const searchQuery: EntitiesRequestQuery = {
      ...query,
      nameQuery: _get(query, 'q'),
      entityTypeId: entityType.id,
    };
    if (!migrationInProgress && entityType.id) {
      dispatch(getEntitiesList({ query: searchQuery }));
    }
  }, [search, migrationInProgress, entityType.id, lastSyncStatusInfo]);

  return (
    <Loader status={fetchPagesStatus} style={{ display: 'contents' }}>
      {() => (
        <PagesTab
          hasQuery={search.length > 0}
          entityType={entityType}
          migrationInProgress={migrationInProgress}
          pagesData={pagesData}
          lastSyncStatusInfo={lastSyncStatusInfo}
          onDeleteEntity={handleDeleteEntity}
          onReload={onReload}
        />
      )}
    </Loader>
  );
}

export default Container;
